import { render, staticRenderFns } from "./LivestreamRouting.vue?vue&type=template&id=63c69375"
import script from "./LivestreamRouting.vue?vue&type=script&lang=js"
export * from "./LivestreamRouting.vue?vue&type=script&lang=js"
import style0 from "./LivestreamRouting.vue?vue&type=style&index=0&id=63c69375&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports